import { DatePicker } from "antd";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useFormik } from "formik";
import moment from "moment/moment";
import Notiflix from "notiflix";
import { Helmet } from "react-helmet";
import * as Yup from "yup";
// import reservation from "../../../assets/img/valentines-banner.jpeg";
import reservation from "../../../assets/img/masala-banner.webp";
// import reservation from "../../../assets/img/offer.jpg";
import PostApiCall from "../../../helper/PostAPI";
import "../assets/css/style.css";
import "../Catering/Catering.css";
import Footer from "../Footer/Footer";
import CommonHomeNavbar from "../Navbar/CommonHomeNavbar";
import "./ResrvationPage.css";

dayjs.extend(customParseFormat);

export default function ResrvationPage() {
  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      people: "",
      date: "",
      comments: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("This field is required*"),
      phone: Yup.string()
        .matches(/^\d+$/, "Phone number is invalid")
        .required("This field is required*"),
      email: Yup.string()
        .email("Email is Invalid")
        .required("This field is required*"),
      people: Yup.string()
        .matches(/^\d+$/, "Amount of people is invalid")
        .required("This field is required*"),
      date: Yup.string()
        .required("This field is required*")
        .test(
          "valid-date",
          "Invalid date",
          (value) =>
            !value || dayjs(value, "MM-DD-YYYY hh:mm A", true).isValid()
        ),
    }),
    onSubmit: (values) => {
      const { name, phone, email, people, date, comments } = values;
      sendMail(name, phone, email, people, date, comments);
      formik.resetForm();
    },
  });

  // send mail to the admin
  function sendMail(name, phone, email, people, date, comments) {
    // const formattedDate = moment(date).format("YYYY-MM-DD hh:mm a");  formate 2024-05-21
    // const formattedDate = moment(date).format("MM-DD-YYYY hh:mm a");  formate 05-21-2024
    const formattedDate = moment(date, "MM-DD-YYYY hh:mm A", true).format(
      "MMMM DD, YYYY hh:mm a"
    );
    Notiflix.Loading.Dots("Please Wait...");
    PostApiCall.postRequest(
      {
        id: null,
        type: "Reservation",
        contactperson: name,
        contactnumber: phone,
        email: email,
        peoplecount: people,
        pickupdate: formattedDate,
        message: comments,
      },
      "reservationenquiry"
    ).then((result) =>
      result?.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          Notiflix.Loading.Remove();
          Notiflix.Notify.Success("Your form has been submitted successfully. Our team will get back to you shortly.");
        } else {
          Notiflix.Notify.Failure("Failed");
        }
      })
    );
  }

  return (
    <>
      <CommonHomeNavbar />

      <Helmet>
        {/* meta tags */}
        <title>
          Reservations | Masala Of India Cuisine - Best Indian Restaurant in
          Northgate, Seattle - WA
        </title>
        <meta
          name="description"
          content="Reserve your table online at Masala of India Cuisine for enjoying the Best Authentic flavors of Indian Food. We are open for an Exclusive Lunch Buffet and Dinner"
        />
        <meta
          name="keywords"
          content="Masala of India Cuisine, Table Reservation, Table reservation for dine-in, Book your table, Online Table reservations, Best Indian Restaurant in Northgate, Best Indian Restaurant in Seattle, Best Indian Restaurant in Washington - WA, Best Indian Food, Authentic Indian Food, Indian Lunch Buffet, Lunch Buffet, Tandoori Food, North Indian food in Seattle, Halal Food in Seattle, Halal Food in Northgate, North Indian Food, Indian Food Catering, Catering Services in Seattle, Best Catering Services in Seattle, Indian Restaurants near me, Lunch Buffet Near me, Best Indian Restaurant Near me, Sanjay Sharma, Chef Sanjay Sharma, Indian Ala carte Food, To-go Indian Food, Indian Food Delivery, Order Indian Food Online,
          diner, takeaway, indian takeaway, caterer, lunch restaurant, buffet restaurant, family restaurant, free dining restaurant, north indian restaurant, To-Go & Food Delivery, Online Ordering, Table reservations, Baby Showers, Bridal Showers, Rehearsal Dinner, Retirement, Greenwood, Seattle, WA, USA, Northgate, Seattle, WA, USA, Green Lake, Seattle, WA, USA, Maple Leaf, Seattle, WA, USA, Haller Lake, Seattle, WA, USA, Licton Springs, Seattle, WA, USA, Wedgwood, Seattle, WA 98115, USA, Pinehurst, Seattle, WA 98125, USA, Roosevelt, Seattle, WA 98115, USA, Victory Heights, Seattle, WA, USA, Bitter Lake, Seattle, WA 98133, USA, Morningside, Seattle, WA 98115, USA"
        />

        {/* OG tags */}
        <meta
          property="og:title"
          content="Reservations | Masala Of India Cuisine - Best Indian Restaurant in Northgate, Seattle - WA"
        />
        <meta
          property="og:description"
          content="Reserve your table online at Masala of India Cuisine for enjoying the Best Authentic flavors of Indian Food. We are open for an Exclusive Lunch Buffet and Dinner"
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.masalaofindia.com/reservation"
        />
        <meta
          property="og:image"
          content="  https://www.masalaofindia.com/static/media/inner-banner.e315c31bfa6eb8d37bb1.jpg"
        />
        <meta property="og:site_name" content="masala of india cuisine" />

        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Reservations | Masala Of India Cuisine - Best Indian Restaurant in Northgate, Seattle - WA"
        />
        <meta
          name="twitter:description"
          content="Reserve your table online at Masala of India Cuisine for enjoying the Best Authentic flavors of Indian Food. We are open for an Exclusive Lunch Buffet and Dinner"
        />
        <meta
          name="twitter:image"
          content="https://www.masalaofindia.com/static/media/inner-banner.e315c31bfa6eb8d37bb1.jpg"
        />
        <meta name="twitter:site" content="masala of india cuisine" />

        <link
          rel="canonical"
          href="https://www.masalaofindia.com/reservation"
        ></link>
      </Helmet>

      <div class="page-header reservationBreadcrumb">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="page-header-box">
                <h1 class="text-anime">Reserve Your Table</h1>
                <nav>
                  <ol class="breadcrumb wow fadeInUp" data-wow-delay="0.50s">
                    <li class="breadcrumb-item">
                      <a href="/">Home</a>
                    </li>
                    <li class="breadcrumb-item active">Reservation</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="book-table-section book-reservation-section my-4 my-lg-5">
        <div className="container-md container-fluid px-0 px-3">
          <div className="row justify-content-center">
            <div className="col-lg-12">
              <div className="content">
                <div className="section-header mb-1">
                  {/* <h2>Serve happiness to your guests</h2> */}
                  <h2 className="lh-base">
                    Experience the Best Indian Cuisine in Seattle
                  </h2>
                  <h3 className="lh-base">
                    Book Your Table for an Authentic Indian Dining Experience
                  </h3>
                  <p>
                    At our restaurant, we are excited to offer a memorable
                    experience with authentic Indian food in the heart of
                    Seattle. Whether you are planning a cozy dinner, a special
                    celebration, or a business gathering, we make it easy to
                    enjoy delicious Indian cuisine with your loved ones. We
                    offer convenient table reservations to ensure your spot is
                    secured in advance. Our team is dedicated to providing
                    exceptional service, and with a reservation, you can enjoy
                    your meal without any wait. Indulge in the vibrant flavors
                    and aromas of Indian cuisine at Masala Of India Cuisine. Our
                    carefully curated{" "}
                    <a className="text-primary" href="/menu">
                      menu{" "}
                    </a>{" "}
                    offers a delectable array of traditional and contemporary
                    dishes, each prepared with fresh ingredients and authentic
                    spices.
                  </p>
                  <p>
                    If you have any special requests or dietary preferences,
                    feel free to let us know when making your local table
                    reservations. Book your table now and let us take care of
                    the rest!
                  </p>
                </div>
              </div>

              {/*  ***** Reservation form **** */}
              <div className="row flex-lg-row flex-column-reverse">
                <div className="book-table-box col-lg-7 my-3 mx-auto">
                  {/* <div className="book-table-box col-12 my-3 mx-auto"> */}
                  <div className="book-form">
                    <form onSubmit={formik.handleSubmit}>
                      <div className="row">
                        <div className="col-12 col-md-4 mb-4">
                          <input
                            className="form-control form-control-lg"
                            type="text"
                            placeholder="Full Name *"
                            aria-label=".form-control-lg example"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.name && formik.errors.name ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.name}
                            </div>
                          ) : null}
                        </div>

                        <div className="col-12 col-md-4 mb-4">
                          <input
                            className="form-control form-control-lg"
                            type="text"
                            placeholder="Phone Number *"
                            aria-label=".form-control-lg example"
                            name="phone"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.phone && formik.errors.phone ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.phone}
                            </div>
                          ) : null}
                        </div>

                        <div className="col-12 col-md-4 mb-4">
                          <input
                            className="form-control form-control-lg"
                            type="email"
                            placeholder="Email Address *"
                            aria-label=".form-control-lg example"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.email && formik.errors.email ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.email}
                            </div>
                          ) : null}
                        </div>

                        <div className="col-12 col-md-6 mb-4">
                          <input
                            className="form-control form-control-lg"
                            type="text"
                            placeholder="Number of People *"
                            aria-label=".form-control-lg example"
                            name="people"
                            value={formik.values.people}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          />
                          {formik.touched.people && formik.errors.people ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.people}
                            </div>
                          ) : null}
                        </div>

                        {/* **** show formate in yyyy-mm-dd */}
                        {/* <div className="col-12 col-md-6 mb-4 datepicker-size">
                          <DatePicker
                            placeholder="Date and Time *"
                            showTime={{ format: "hh:mm A" }}
                            className="form-control form-control-lg catering-label"
                            value={
                              formik.values.date
                                ? moment(formik.values.date)
                                : null
                            }
                            onChange={(date, dateString) =>
                              formik.setFieldValue("date", dateString)
                            }
                            onBlur={formik.handleBlur("date")}
                            disabledDate={(current) =>
                              current && current < moment().startOf("day")
                            } // To disable past dates
                          />
                          {formik.touched.date && formik.errors.date ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.date}
                            </div>
                          ) : null}
                        </div> */}

                        {/* **** show formate in mm-dd-yyyy */}
                        <div className="col-12 col-md-6 mb-4 datepicker-size">
                          <DatePicker
                            placeholder="Date and Time *"
                            showTime={{ format: "hh:mm A" }}
                            format="MM-DD-YYYY hh:mm A"
                            className="form-control form-control-lg catering-label"
                            value={
                              formik.values.date &&
                              dayjs(
                                formik.values.date,
                                "MM-DD-YYYY hh:mm A",
                                true
                              ).isValid()
                                ? dayjs(
                                    formik.values.date,
                                    "MM-DD-YYYY hh:mm A",
                                    true
                                  )
                                : null
                            }
                            onChange={(date) => {
                              formik.setFieldValue(
                                "date",
                                date ? date.format("MM-DD-YYYY hh:mm A") : ""
                              );
                            }}
                            onBlur={() => formik.setFieldTouched("date", true)}
                            disabledDate={(current) =>
                              current &&
                              current.isBefore(dayjs().startOf("day"))
                            }
                          />

                          {formik.touched.date && formik.errors.date ? (
                            <div style={{ color: "red" }}>
                              {formik.errors.date}
                            </div>
                          ) : null}
                        </div>

                        <div className="col-12 mb-1">
                          <textarea
                            className="form-control form-control-lg catering-textarea"
                            id="validationTextarea"
                            placeholder="Message"
                            name="comments"
                            value={formik.values.comments}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                          ></textarea>
                        </div>

                        <div className="col-lg-12 text-left">
                          <button type="submit" className="custom-button">
                            Reserve Your Table
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div className="col-lg-5 my-3">
                  <img
                    className="w-100 h-100 mother-day-img-radius"
                    src={reservation}
                    alt="indian restaurant northgate seattle"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
